import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import Utils from 'helpers/utils.js';
import { Button } from '@kambria/kambria-lego';
import { getLicenseByUser } from 'redux/actions/codeBase2/codeBase2.action';
import enums from 'helpers/const';

const INITAL_LIMIT = 5;
const PAYMENT_METHODS = Utils.setValueLikeKeyObject(enums.PAYMENT_METHODS);

class NftLicense extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      listLicenses: []
    }
  }
  componentDidMount = async () => {
    const { getLicenseByUser } = this.props
    const licenseUsers = await getLicenseByUser();
    this.setState({ listLicenses: licenseUsers.data });
  }

  renderStatusTransaction = (status) => {
    switch (status) {
      case '0':
        return <span style={{ color: 'orange' }}>PENDING</span>;
      case '1':
        return <span style={{ color: 'limegreen' }}>SUCCESSFUL</span>;
      case '2':
        return <span style={{ color: 'red' }}>FAIL</span>;
      case '3':
        return <span style={{ color: 'gray' }}>CANCELLED</span>;
      default:
        return null;
    }
  };

  getPayPrice = ({ payment_method, total_price, type, product }) => {
    const { price, price_usd } = product;
    let pay = '';
    if ([PAYMENT_METHODS.KAT, PAYMENT_METHODS.KAT_WALLET].includes(payment_method)) {
      pay = `${total_price}KAT`;
    }
    if ([PAYMENT_METHODS.KYTE, PAYMENT_METHODS.KYTE_WALLET].includes(payment_method)) {
      pay = `${total_price}KYTE`;
    }
    if (payment_method === PAYMENT_METHODS.PAYPAL) {
      pay = Utils.formatPrice({ price: price_usd, type });
    }
    if (payment_method === PAYMENT_METHODS.VNBANK) {
      pay = Utils.formatPrice({ price, type });
    }
    console.log('pay', pay);
    return pay;
  };

  render() {
    const { listLicenses } = this.state;
    return (
      <div className="px-4">
        <h3 className="title mt-3 mb-5">NFT Licenses</h3>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th className="text-left pr-2">NFT Name</th>
                <th className="text-left pr-2">Paid Amount</th>
                <th className="text-left pr-2">Purchase date</th>
                <th className="text-left pr-2">Transaction Hash</th>
              </tr>
            </thead>
            {
              listLicenses.map((item, index) => {
                if (!item) return null
                const style = {
                  color: '#97a4ad',
                  fontSize: '13px',
                  whiteSpace: 'nowrap',
                };
                const createOrderDate = moment(item.purchaseDate).format('YYYY-MM-DD HH:mm:ss');
                return (
                  <tr key={index}>
                    <td className="w-100 pr-2" style={style}>
                      {item.nftName}
                    </td>
                    <td className="w-100 pr-2" style={style}>
                      {item.paidAmount}
                    </td>
                    <td className="w-100 pr-2" style={style}>
                      {createOrderDate}{' '}
                    </td>
                    <td className="w-100 pr-2" style={style}>
                      {item.transactionHash}
                    </td>
                  </tr>
                );
              })
            }
            <tbody>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ }) => ({});

const mapDispatchToProps = {
  getLicenseByUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(NftLicense);
